// Detección de país por IP + tasas de cambio para mostrar precios localizados.
// Todas las APIs son gratuitas y sin token. Cachea en localStorage para
// minimizar requests y degradar gracefully si fallan.

const CACHE_COUNTRY_KEY = "zenviq_user_country";
const CACHE_FX_KEY = "zenviq_fx_rates";
const COUNTRY_TTL_MS = 24 * 60 * 60 * 1000; // 24h
const FX_TTL_MS = 60 * 60 * 1000;            // 1h

const COUNTRY_TO_CURRENCY = {
  CO: "COP", MX: "MXN", CL: "CLP", AR: "ARS",
  PE: "PEN", BR: "BRL", UY: "UYU", VE: "VES",
  EC: "USD", BO: "BOB", PY: "PYG",
};

const CURRENCY_META = {
  USD: { symbol: "$",   locale: "en-US",  name: "US Dollar"        },
  COP: { symbol: "$",   locale: "es-CO",  name: "Peso colombiano"  },
  MXN: { symbol: "$",   locale: "es-MX",  name: "Peso mexicano"    },
  CLP: { symbol: "$",   locale: "es-CL",  name: "Peso chileno"     },
  ARS: { symbol: "$",   locale: "es-AR",  name: "Peso argentino"   },
  PEN: { symbol: "S/",  locale: "es-PE",  name: "Sol peruano"      },
  BRL: { symbol: "R$",  locale: "pt-BR",  name: "Real brasileño"   },
  UYU: { symbol: "$U",  locale: "es-UY",  name: "Peso uruguayo"    },
  BOB: { symbol: "Bs",  locale: "es-BO",  name: "Boliviano"        },
  PYG: { symbol: "₲",   locale: "es-PY",  name: "Guaraní"          },
};

function readCache(key, ttl) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const { value, ts } = JSON.parse(raw);
    if (Date.now() - ts > ttl) return null;
    return value;
  } catch {
    return null;
  }
}

function writeCache(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify({ value, ts: Date.now() }));
  } catch {
    /* ignore quota / privacy mode */
  }
}

export async function detectUserCountry() {
  const cached = readCache(CACHE_COUNTRY_KEY, COUNTRY_TTL_MS);
  if (cached) return cached;
  try {
    const res = await fetch("https://ipapi.co/json/", { cache: "no-store" });
    if (!res.ok) return null;
    const data = await res.json();
    const code = (data.country_code || "").toUpperCase();
    if (code) writeCache(CACHE_COUNTRY_KEY, code);
    return code || null;
  } catch {
    return null;
  }
}

export function currencyForCountry(code) {
  return COUNTRY_TO_CURRENCY[code] || "USD";
}

export async function fetchFxRates() {
  const cached = readCache(CACHE_FX_KEY, FX_TTL_MS);
  if (cached) return cached;
  try {
    const res = await fetch("https://open.er-api.com/v6/latest/USD", { cache: "no-store" });
    if (!res.ok) return null;
    const data = await res.json();
    if (data.result !== "success" || !data.rates) return null;
    writeCache(CACHE_FX_KEY, data.rates);
    return data.rates;
  } catch {
    return null;
  }
}

export function convertFromUSD(amountUSD, currency, rates) {
  if (!rates || !rates[currency]) return null;
  return amountUSD * rates[currency];
}

export function formatAmount(amount, currency) {
  const meta = CURRENCY_META[currency] || CURRENCY_META.USD;
  const formatted = Number(amount).toLocaleString(meta.locale, {
    style: "currency",
    currency,
    maximumFractionDigits: currency === "USD" ? 2 : 0,
  });
  return formatted;
}

export { CURRENCY_META };
